module.exports = function() {
    var Urls = {};
    const urlUtil = require('url');

    // http://stackoverflow.com/a/901144/554602
    Urls.getParameterByName = function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };

    //http://stackoverflow.com/a/1634841/554602
    Urls.removeParameter = function (parameter, url) {
        //prefer to use l.search if you have a location/link object
        var urlparts = url.split('?');
        if (urlparts.length>=2) {
            var prefix = encodeURIComponent(parameter)+'=';
            var pars = urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i= pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
            return url;
        } else {
            return url;
        }
    };

    Urls.addParameter = function(parameter, value, url) {
        var urlParts = url.split('?');
        url += (urlParts.length > 0 ? '?' : '&');
        url += parameter + '=' + value;
        return url;
    };

    /**
     * Get the P2A CDN Url based on environment
     * @param requestorUrl
     * @returns string
     */
    Urls.getP2aCdnUrl = function(requestorUrl) {
        const environment = Urls.getEnv(requestorUrl)
        const envToCdn = {
            production: 'https://cdn.p2a.co',
            staging: 'https://cdn.s.p2a.co',
            qa: 'https://cdn.qa.p2a.co',
            local: 'https://cdn-local.p2a.co'
        }
        return envToCdn[environment]
    }

    /**
     * Gets the P2A environment from given URL
     * @param urlToProcess
     * @returns string
     */
    Urls.getEnv = function(urlToProcess) {
        const parsedUrl = urlUtil.parse(urlToProcess)
        const processedHost = parsedUrl.host.split(".")[0]
        if(processedHost === 'local') {
            return 'local';
        } else if (processedHost ==='staging') {
            return 'staging';
        } else if(processedHost === 'qa') {
            return 'qa';
        } else {
            return 'production';
        }
    }

    return Urls;
};